$(window).on('load', function(){
    var dateTimeEl = $('.timer-new').attr('datetime');

    // Fix timezone to ISO 8601 (e.g. +0100 → +01:00)
    const fixedDateTime = dateTimeEl.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");

    // Parse into Date object
    const targetDate = parseCustomDate(dateTimeEl);

    function parseCustomDate(str) {
        const match = str.match(/^(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)\.\d+([+-]\d{2})(\d{2})$/);
        if (!match) return null;

        const [ , year, month, day, hour, min, sec, tzH, tzM ] = match.map(Number);
        const date = new Date(Date.UTC(year, month - 1, day, hour - tzH, min - tzM, sec));
        return date;
    }

    if (isNaN(targetDate)) {
        console.error('Invalid Date parsed. Aborting.');
        return;
    }

    function updateCountdown() {
        const currentDate = new Date();
        const timeDifference = targetDate - currentDate;

        if (timeDifference <= 0) {
            $('.timer-new span:not(.timer_expair_text)').hide();
            $('.timer-new .timer_expair_text').show();
        } else {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            $("#new_days").text(days.toString().padStart(2, "0"));
            $("#new_hours").text(hours.toString().padStart(2, "0"));
            $("#new_minutes").text(minutes.toString().padStart(2, "0"));
            $("#new_seconds").text(seconds.toString().padStart(2, "0"));
        }
    }

    setInterval(updateCountdown, 1000);
    updateCountdown();
});